// Stores and ecom Ids are synonymous with each other. But using different ids for clarity.
export const STORES_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const NEW_STORES_APP_DEF_ID = '215238eb-22a5-4c36-9e7b-e7c08025e04e';
export const PAID_PLANS_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
export const STORES_SHOP_SECTION_ID = 'product_gallery';
export const STORES_CATEGORY_SECTION_ID = 'Category Page';
const SETTINGS_APP_DEF_ID_BY_ORIGIN_APP_ID: Record<string, string> = {
  [STORES_APP_DEF_ID]: NEW_STORES_APP_DEF_ID,
};
export const toSettingsAppDefId = (originAppId: string) =>
  SETTINGS_APP_DEF_ID_BY_ORIGIN_APP_ID[originAppId] ?? originAppId;
export const TIME_UNTIL_SUCCESS_TOAST_DISAPPEARS = 5000;
export const TIME_UNTIL_ERROR_TOAST_DISAPPEARS = 10000;

export enum UpmFlowStatus {
  INIT = 'init',
  PENDING = 'pending',
}

export enum PayNowFlowStatus {
  INIT = 'init',
  PENDING = 'pending',
  VALIDATED_GRACE_PERIOD = 'validatedGracePeriod',
}
